import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getRequest } from 'utils/requests';
import { Forecast, PageTitle } from 'components/common/Elements/Elements';
import { getQuarter, textToDateM } from 'utils/common';

const ArrActivityHeader = () => {
  const [headerData, setHeaderData] = useState({});

  const { t } = useTranslation(['activity']);

  const today = new Date();
  const year = today.getFullYear();
  const quarter = getQuarter(today);
  const month = textToDateM(today, 'l');

  useEffect(() => {
    let cancelled = false;
    getRequest('/mrr/activity/header')
      .then(res => {
        !cancelled && setHeaderData(res.body);
      })
      .catch(err => {
        !cancelled && console.log(err);
      });
    return () => (cancelled = true);
  }, []);

  const data = [
    {
      header: t('activity:arrActivity.TOTAL_ARR'),
      amount: headerData.totalArr ? headerData.totalArr : ''
    },
    {
      header: `${t(
        'activity:arrActivity.CURRENT_QUARTER'
      )} (Q${quarter} ${year})`,
      amount: headerData.currQuarterArr ? headerData.currQuarterArr : ''
    },
    {
      header: `${t('activity:arrActivity.CURRENT_MONTH')} (${month} ${year})`,
      amount: headerData.currMonthArr ? headerData.currMonthArr : ''
    }
  ];

  return (
    <>
      <PageTitle title={t('activity:arrActivity.ARR_ACTIVITY')} />
      <Forecast data={data} />
    </>
  );
};

export default ArrActivityHeader;
